// Ürün varyantları — tek ürün, sepette varyant satırı.
// Varyantlar koda gömülü (fiyat/stok tüm varyantlarda aynı); sepette satır
// kimliği slug + variant'tır. Yeni varyantlı ürün: slug'ı buraya ekle.

const VARIANTS: Record<string, string[]> = {
  "qnail-silk-cat-eye": Array.from({ length: 20 }, (_, i) => `Renk ${String(i + 1).padStart(2, "0")}`),
};

export function getVariants(slug: string): string[] {
  return VARIANTS[slug] ?? [];
}

export function hasVariants(slug: string): boolean {
  return (VARIANTS[slug]?.length ?? 0) > 0;
}
